import { useState } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import { cuotasSelect, planesSelect } from "../data";
import { Alert, Col, Row } from "react-bootstrap";

const ARSLocale = Intl.NumberFormat("es-AR");

function CalculadoraCuotas() {
  const [showResults, setShowResults] = useState(false);
  const [form, setForm] = useState({
    valorAuto: "",
    plan: "",
    cuotas: "",
  });

  const handleChangeSelect = (e) => {
    setShowResults(false);
    setForm((form) => ({
      ...form,
      [e.target.name]: e.target.value,
    }));
  };

  const handleCheckDisabledSubmit = () => {
    if (form.valorAuto && form.plan && form.cuotas) return false;
    return true;
  };

  const handleSubmit = () => {
    setShowResults(true);
  };

  const getDineroMask = (value) => "$" + ARSLocale.format(value);

  const getCuotaPura = () => {
    const valorFinanciado = form.plan.split("/")[0];
    return Number(
      ((form.valorAuto * valorFinanciado) / 100 / form.cuotas).toFixed(2)
    );
  };

  const getGastosAdministrativos = () =>
    Number((getCuotaPura() * 0.1).toFixed(2));

  return (
    <Container className="p-4" fluid style={{ maxWidth: 1200 }}>
      <h2>Calculadora de cuotas</h2>
      <p className="fs-3">
        Para continuar por favor complete el siguiente formulario
      </p>
      <Form>
        <Row>
          <Col md={6}>
            <Form.Group className="m-2">
              <Form.Label>Valor del vehículo</Form.Label>
              <Form.Control
                type="text"
                placeholder="Ingrese el valor del auto sin puntos ni coma."
                onChange={handleChangeSelect}
                name="valorAuto"
              />
              <Form.Text value={form.valorAuto}>
                Por ejemplo, si el vehículo tiene un valor de $5.690.200,
                ingrese solo los numeros: 5690200
              </Form.Text>
            </Form.Group>
          </Col>
        </Row>

        <Row>
          <Col md={6}>
            <Form.Group className="m-2">
              <Form.Label>Plan</Form.Label>
              <Form.Select
                name="plan"
                onChange={handleChangeSelect}
                value={form.plan}
              >
                <option disabled value="">
                  Seleccione un Plan
                </option>
                {planesSelect.map((plan) => (
                  <option key={plan.name} value={plan.name}>
                    {plan.name}%
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>

        <Row>
          <Col md={6}>
            <Form.Group className="m-2">
              <Form.Label>Cantidad de cuotas</Form.Label>
              <Form.Select
                name="cuotas"
                onChange={handleChangeSelect}
                value={form.cuotas}
              >
                <option disabled value="">
                  Seleccione la cantidad de cuotas
                </option>
                {cuotasSelect.map((cuota) => (
                  <option key={cuota} value={cuota}>
                    {cuota}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>
        <Button
          className="m-3"
          variant="primary"
          onClick={handleSubmit}
          disabled={handleCheckDisabledSubmit()}
        >
          Calcular
        </Button>
      </Form>
      {showResults && (
        <div>
          <Alert variant="warning">
            <span className="fw-bold">
              Los cálculos son estimativos. Puede haber diferimientos que
              cambien el valor de la cuota. A esos ítems se suman los seguros de
              vida y sobre el auto.
            </span>
          </Alert>
          <div>
            <span className="fw-semibold fs-5">
              Valor de cuota pura/alícuota:{"  "}
            </span>
            <span className="fs-5">{getDineroMask(getCuotaPura())}</span>
          </div>
          <div className="mt-1">
            <span className="fw-semibold fs-5">
              Valor de costos de administración:{"  "}
            </span>
            <span className="fs-5">
              {getDineroMask(getGastosAdministrativos())}
            </span>
          </div>
          <div className="mt-1">
            <span className="fw-semibold fs-5">
              Valor total a pagar por cuota:{"  "}
            </span>
            <span className="fs-5">
              {getDineroMask(getGastosAdministrativos() + getCuotaPura())}
            </span>
          </div>
          {form.plan !== "100%" && (
            <Alert variant="info">
              <span className="fw-bold">
                Estás pagando el {form.plan.split("/")[0]}% del valor del auto.
              </span>
              <br />
              <span className="fw-bold">
                El {form.plan.split("/")[1]}% restante lo pagarás cuando
                resultes adjudicatario
              </span>
            </Alert>
          )}
        </div>
      )}
    </Container>
  );
}

export default CalculadoraCuotas;
